import { memo, useCallback } from 'react'
import DateRangePicker, { DateRangePickerProps } from '../DateRangePicker'
import { DatePickerProps } from './DatePicker.types'

function DatePicker({ value, onChange, ...props }: DatePickerProps) {
  const onChangeWrapper = useCallback(
    (newValue: DateRangePickerProps['value']) => {
      onChange(newValue.startDate)
    },
    [onChange],
  )
  const valueWrapper = { startDate: value ?? null, endDate: null }
  return <DateRangePicker value={valueWrapper} onChange={onChangeWrapper} singleDate {...props} />
}

export default memo(DatePicker)
